import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import PATCH_COURSE from '../mutations/PATCH_COURSE';

const usePatchCourse = () => {
    const [ patchCourse ] = useMutation( PATCH_COURSE );

    const saveCourse = async ( saveData ) => {
        try {  
            const response = await patchCourse(  { variables: { input: saveData } } );
            const success = response?.data?.result?.id;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error saving course', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            saveCourse
        };
    }, [] );
};

export default usePatchCourse;
